import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ClientPortal from "@/pages/ClientPortal";
import AdminPortal from "@/pages/AdminPortal";

function Protected({ children, role }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen bg-[#1A1A1F] flex items-center justify-center text-[#A1A1AA] font-mono uppercase tracking-widest text-xs">
        // Cargando...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/portal"} replace />;
  return children;
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/portal" element={<Protected role="client"><ClientPortal /></Protected>} />
              <Route path="/admin" element={<Protected role="admin"><AdminPortal /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#1F1F25",
                border: "1px solid #2E2E33",
                color: "#FAFAFA",
                borderRadius: 0,
                fontFamily: "'IBM Plex Sans', sans-serif",
              },
            }}
          />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
